import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'

// let ferryUrl = '/gateway-test/api-agent'
/**
 * 获取代理商管理分页数据
 * @param agentQueryParam
 */
export const selectAgentPage = (agentQueryDto) => {
  return request({
    url: env.agentUrl + '/agent/admin/page',
    method: 'POST',
    data: agentQueryDto
    // param: agentQueryDto
    // params: JSON.stringify(agentQueryParam)
  })
}

/**
 * 编辑代理商
 * @param agentVo
 */
export const editAgent = (agentVo) => {
  return request({
    url: env.agentUrl + '/agent/admin/edit',
    method: 'POST',
    data: agentVo
  })
}

/**
 * 代理商审核通过
 * @param auditPassDto
 */
export const agentCheckPass = (auditPassDto) => {
  return request({
    url: env.agentUrl + '/agent/admin/auditPass',
    method: 'POST',
    data: auditPassDto
  })
}

/**
 *代理商审核不通过
 * @param params
 */
export const agentNoCheck = (params) => {
  return request({
    url: env.agentUrl + '/agent/admin/auditNoPass',
    method: 'PUT',
    params
  })
}

/**
 *查看代理商详情
 * @param agentId
 */
export const getAgentInfo = (agentId) => {
  return request({
    url: env.agentUrl + `/agent/admin/detail/${agentId}`,
    method: 'GET'
  })
}

/**
 * 获取代理商二维码
 */
export const getQrCode = (agentId) => {
  return request({
    url: env.agentUrl + `/agent/admin/queryAgentQrcode/${agentId}`,
    method: 'PUT'
  })
}

/**
 * 代理商提成明细分页
 * @param agentOrder4ExportDto
 */
export const agentInfoPage = (agentOrder4ExportDto) => {
  return request({
    url: env.agentUrl + '/agent/order/page',
    method: 'POST',
    data: agentOrder4ExportDto
  })
}

/**
 * 导出代理商提成明细
 * @param agentOrder4ExportDto
 */
/* export const exportAgentInfo = (agentOrder4ExportDto) => {
    return request({
        url: env.agentUrl+'/agent/order/export',
        method: 'POST',
        data: agentOrder4ExportDto,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    })
} */
/**
 * 导出代理商提成明细
 * @param agentOrder4ExportDto
 */
export const exportAgentInfo = (queryParam) => {
  let url = env.importExcelUrl + env.agentUrl + '/agent/order/export'
  const parma = pickBy({ ...queryParam })
  url = url + '?' + qs.stringify(parma)
  window.location.href = url
}

/**
 * 导出代理商提成明细
 * @param agentOrder4ExportDto
 */
export const exportPay = (queryParam) => {
  let url = env.importExcelUrl + env.agentUrl + '/agent/pay/export'
  const parma = pickBy({ ...queryParam })
  url = url + '?' + qs.stringify(parma)
  window.location.href = url
}

/**
 * 代理商提现申请分页
 * @param withdrawalQueryDto
 */
export const agentApplyPage = (withdrawalQueryDto) => {
  return request({
    url: env.agentUrl + '/agent/withdraw/page',
    method: 'POST',
    data: withdrawalQueryDto
  })
}

/**
 * 代理商提现申请详情
 * @param withdrawalId
 */
export const agentApplyInfo = (withdrawalId) => {
  return request({
    url: env.agentUrl + `/agent/withdraw/info/${withdrawalId}`,
    method: 'GET'
  })
}

/**
 * 代理商提现审核
 * @param withdrawalId
 */
export const agentApplyCheck = (withdrawalId, auditStatus, remark) => {
  return request({
    url: env.agentUrl + '/agent/withdraw/audit',
    method: 'PUT',
    data: {
      withdrawalId,
      auditStatus,
      remark
    }
  })
}

/**
 * 代理商提现详情分页
 * @param withdrawalId
 */
export const agentApplyDetailPage = (data) => {
  return request({
    url: env.agentUrl + '/agent/withdraw/cash-out/page',
    method: 'POST',
    data
  })
}

/**
 * 代理商打款记录分页
 * @param withdrawalPayDto
 */
export const agentNotePage = (withdrawalPayDto) => {
  return request({
    url: env.agentUrl + '/agent/pay/page',
    method: 'POST',
    data: withdrawalPayDto
  })
}

/**
 * 代理商打款
 * @param data
 */
export const agentAuditPay = (data) => {
  return request({
    url: env.agentUrl + '/agent/pay/pay',
    method: 'POST',
    data
  })
}
/**
 * 代理商打款
 * @param data
 */
export const batchPay = (data) => {
  return request({
    url: env.agentUrl + '/agent/pay/payList',
    method: 'POST',
    data
  })
}

/**
 * 获取特殊行程
 */
export const selectSuperTrip = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineList',
    method: 'GET'
  })
}

/**
 * 封禁代理商
 * * @param data
 */
export const banAgent = (data) => {
  return request({
    url: env.agentUrl + '/agent/admin/ban',
    method: 'POST',
    data
  })
}

/**
 * 封禁代理商
 * * @param data
 */
export const noBanAgent = (data) => {
  return request({
    url: env.agentUrl + '/agent/admin/noban',
    method: 'POST',
    data
  })
}

/**
 * 获取二维码
 * * @param agentId
 */
export const queryAgentQrcode = (agentId) => {
  return request({
    url: env.agentUrl + `/agent/admin/queryAgentQrcode/${agentId}`,
    method: 'GET'
  })
}

// 获取税率
export const getRate = (params) => {
  return request({
    url: env.agentUrl + '/agent/withdraw/tax',
    method: 'GET',
    params
  })
}
// 设置税率
export const setRate = (params) => {
  return request({
    url: env.agentUrl + '/agent/withdraw/tax',
    method: 'POST',
    data: params
  })
}

/**
 * 代理商绑定银行卡
 * @param bandBankCardDto
 */
export const bandBankCard = (bandBankCardDto) => {
  return request({
    url: env.agentUrl + '/agent/admin/band/bank/card',
    method: 'POST',
    data: bandBankCardDto
  })
}

/**
 *地区树
 * @param
 */
export const getAreaTree = (data) => {
  return request({
    url: env.agentUrl + '/agent/admin/area-tree',
    method: 'GET',
    params: data
  })
}

// 批量生成注册二维码
export const batchGenerateQrcode = (data) => {
  return request({
    url: env.agentUrl + '/agent/admin/batch-generate-qrcode',
    method: 'POST',
    data
  })
}

// 下载二维码
export const downloadQrcode = (data) => {
  return request({
    url: env.agentUrl + '/agent/admin/download-qrcode',
    method: 'POST',
    data,
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json;application/octet-stream' }
  })
}
